import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { site } from "@/content";

const ROUTE = "/terms";
export const Route = createFileRoute("/terms")({
  head: () =>
    routeHead(ROUTE, {
      title: "Website Terms | NextEra Bookkeeping",
      description: "Terms that apply to the use of the NextEra Bookkeeping website.",
    }),
  component: Page,
});

function Page() {
  return (
    <div className="bg-background text-foreground">
      <section className="mx-auto max-w-3xl px-6 py-20">
        <h1 className="mt-4 font-serif text-4xl text-[color:var(--navy)] sm:text-5xl">
          Website Terms
        </h1>
        <div className="prose prose-slate mt-10 max-w-none text-[color:var(--ink)]">
          <p>
            These terms govern your use of the {site.brandName} website. By using the site you
            accept these terms.
          </p>
          <h2 className="font-serif text-xl text-[color:var(--navy)]">
            Information on this website
          </h2>
          <p>
            Content is provided for general information and does not constitute financial, tax or
            professional advice. Any engagement is subject to a separate written agreement.
          </p>
          <h2 className="font-serif text-xl text-[color:var(--navy)]">Intellectual property</h2>
          <p>
            All content on this site remains the property of {site.brandName} unless otherwise
            indicated.
          </p>
          <p className="mt-10 text-xs text-[color:var(--subtle)]">{site.legalWording}</p>
        </div>
      </section>
    </div>
  );
}
